import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getOrdersReturn = async (params) => {
	const { data } = await axios.get(`${API}/client/orders_return`, {
		params,
	});
	return data;
};

export const deleteOrderReturn = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/orders_return/delete`, {
		...base,
		element,
	});
	return data;
};
